module.exports = __webpack_public_path__ + "a98a197881952f9430b5d2bae15ce02c.fbx";